import React, { memo, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { CategoryLandingPageSectionBlokProps } from './CategoryLandingPage';
import { formatStringForUrl } from '../../utils/formatStringForUrl/formatStringForUrl.util';

interface CategoryLandingPageSideBarItemProps {
  categoryLandingPageSection: CategoryLandingPageSectionBlokProps;
  categoryLandingPageSectionIndex: number;
  isLastItem: boolean;
  activeCategoryLandingPageSection: string;
}

const CategoryLandingPageSideBarDesktopListItem: React.FC<
  CategoryLandingPageSideBarItemProps
> = ({
  categoryLandingPageSection,
  categoryLandingPageSectionIndex,
  isLastItem,
  activeCategoryLandingPageSection,
}) => {
  const isActive =
    activeCategoryLandingPageSection ===
    formatStringForUrl(categoryLandingPageSection.heading);

  return (
    <li
      key={categoryLandingPageSection._uid}
      className="flex flex-row items-start justify-start gap-x-4 group"
    >
      <div className="flex flex-col items-center">
        <div
          className={classNames(
            'w-8 h-8 rounded-full flex items-center justify-center transition-colors ease-in-out duration-100',
            {
              'bg-[#E5F4F9] text-text/body-accent group-hover:bg-text/body-accent group-hover:text-system/white':
                !isActive,
              'bg-text/body-accent text-system/white': isActive,
            }
          )}
        >
          <p className="font-bold">{categoryLandingPageSectionIndex + 1}</p>
        </div>
        {!isLastItem && (
          <div
            className={classNames(
              'w-[1px] h-10 transition-colors ease-in-out duration-100',
              {
                'bg-[#006FA7]': isActive,
                'bg-border/light': !isLastItem,
              }
            )}
          ></div>
        )}
      </div>
      <a
        className={classNames(
          'w-full h-8 flex items-center justify-start font-bold transition-colors ease-in-out duration-100',
          {
            'text-text/body-accent': isActive,
            'text-text/body-tint group-hover:text-text/body-accent': !isActive,
          }
        )}
        href={`#${formatStringForUrl(categoryLandingPageSection.heading)}`}
      >
        {categoryLandingPageSection.heading}
      </a>
    </li>
  );
};

export default CategoryLandingPageSideBarDesktopListItem;
